import React, { useRef, forwardRef, useImperativeHandle } from "react";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import axios from "axios";
import { Button } from "antd";

const DirectPrint = forwardRef(({
    userDetails,
    userPhone,
    address,
    address1,
    gstNo,
    nextInvNo,
    billNo,
    billDate,
    userName,
    barCodeData = [],
    totalNetAmount = 0,
    base64Images,
    base64QR,
    totalGstData = [],
    ins,
    ins1,
    ins2,
    ins3,
    ins4,
    ins5,
    ins6,
    totalBillAmount,
    totalBillDiSAmt,
    totalBillNetAmount,
    totalBillQty,
    totalExchangeAmount,
    totalExchangeDiSAmt,
    totalExchangeNetAmount,
    totalExchangeQty,
    gstValue,
    cashAmt,
    cardAmt,
    onlineAmt,
    upiAmt,
    creditAmt,
    handlePrint,
    receiptRef },
    ref) => {
    // const receiptRef = useRef(null);

    // const handlePrint = async () => {
    //     try {
    //         const canvas = await html2canvas(receiptRef.current, {
    //             scale: 4,
    //             backgroundColor: "#fff",
    //             useCORS: true,
    //         });

    //         const base64 = canvas.toDataURL("image/png").split(",")[1];

    //         await axios.post("http://localhost:5442/api/print/silent", {
    //             fileBase64: base64,
    //             printerName: "Essae PR-55",
    //         });
    //     } catch (err) {
    //         console.error("Print failed", err);
    //     }
    // };

    useImperativeHandle(ref, () => ({
        print: handlePrint,
    }));

    const formatNum = (val = 0, dec = 2) =>
        Number(val || 0)
            .toFixed(dec)
            .replace(/\.00$/, "");

    // if (!printData) return null;

    /* ================= STYLES ================= */

    const receiptStyle = {
        position: "absolute",
        top: "-10000px",
        left: "-10000px",
        fontFamily: "monospace",
        color: "#000",
        background: "#fff",
        lineHeight: "1.2",
        width: "250px",
        padding: "6px",
        boxSizing: "border-box",
    };

    const row = {
        display: "flex",
        alignItems: "center",
        // marginBottom: "2px",
    };

    const rowWise = {
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
        // marginTop: "1px",
        // marginBottom: "2px",
    };

    /* ---- Fixed Column Alignment ---- */

    const label = {
        // width: "95px",
        fontWeight: 500,
        fontSize: "10px",
    };
    const label4 = {
        // width: "95px",
        fontWeight: 500,
        fontSize: "8px",
    };
    const label2 = {
        fontWeight: 600,
        fontSize: "12px",
        padding: "0px 4px",
        fontFamily: "Arial, Helvetica, sans-serif",
        backgroundColor: "#000",
        borderRadius: "8px",
        color: "#fff",
        // width: "70px", 
        textAlign: "left"
    };

    const colon = {
        width: "15px",
        textAlign: "center",
        fontWeight: 600,
    };

    const value = {
        // flex: 1,
        fontSize: "12px",
        textAlign: "left",
    };

    const value2 = {
        // flex: 1,
        fontSize: "12px",
        fontWeight: 700,
        textAlign: "left",
    };

    /* ---- Totals Alignment ---- */

    const totalRow = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
    };
    const bea = {
        fontSize: "10px",
    };

    const totalBlock = {
        width: "150px",
    };

    const totalLine = {
        display: "flex",
        alignItems: "center",
        // marginBottom: "1px", 
    };

    const totalLine2 = {
        width: "95px",        // label column
        textAlign: "right",
        fontSize: "12px",
    };
    const totalLine3 = {
        width: "95px",        // label column
        textAlign: "right",
        fontSize: "14px",
        fontWeight: "bold",
    };

    const totalColon = {
        width: "10px",
        textAlign: "center",
        fontWeight: 600,
        fontSize: "12px",
    };

    const totalValue = {
        flex: 1,
        textAlign: "right",   // values right aligned
        fontSize: "12px",
    };
    const totalValue2 = {
        flex: 1,
        textAlign: "right",   // values right aligned
        fontSize: "14px",
        fontWeight: "bold",
    };

    /* ---- Payment ---- */

    const cashOrOnline = {
        display: "flex",
        justifyContent: "space-between",
        fontSize: "11px",
        fontWeight: 600,
    };
    const cashOrOnline2 = {
        fontWeight: 600,
        fontSize: "11px",
        padding: "0px 4px",
        fontFamily: "Arial, Helvetica, sans-serif",
        backgroundColor: "#000",
        borderRadius: "8px",
        color: "#fff",
    };

    const header = {
        textAlign: "center",
        fontSize: "18px",
        fontWeight: 700,
    };

    const header2 = {
        textAlign: "center",
        fontSize: "12px",
        fontWeight: 600,
    };

    const lowheader = {
        textAlign: "center",
        fontSize: "12px",
        fontWeight: 500,
    };
    const terms = {
        fontSize: "9px",
    };

    const separator = {
        borderTop: "1px dashed #000",
        marginTop: "4px",
        marginBottom: "4px",
    };

    const footer = {
        textAlign: "center",
        marginTop: "4px",
        fontSize: "10px",
        fontWeight: 500,
    };

    const showValue = (val) =>
        val && val !== "-" && String(val).trim() !== "" && val !== "undefined"
            ? val
            : "-";

    const isValidValue = (val) =>
        val !== null &&
        val !== undefined &&
        val !== "-" &&
        String(val).trim() !== "" &&
        val !== "undefined";

    /* ================= JSX ================= */

    return (
        <>

            {/* <Button type="primary" onClick={handlePrint}>
                Print
            </Button> */}

            <div ref={receiptRef} style={receiptStyle}>
                {/* HEADER */}
                <div style={header}>{userName}</div>
                <div style={lowheader}>{address}</div>
                <div style={lowheader}>{address1}</div>
                <div style={lowheader}>PHONE NO : {showValue(userPhone)}</div>
                <div style={lowheader}>{
                    isValidValue(gstNo)
                        ? <div style={lowheader}>GSTIN: {gstNo}</div>
                        : ""
                }</div>

                <div style={separator}></div>
                <div style={header2}>{gstValue === true ? "TAX INVOICE" : "BILL OF SUPPLY"}</div>
                <div style={separator}></div>

                {/* INV */}
                <div style={row}>
                    <span style={label}>INV NO</span>
                    <span style={colon}>:</span>
                    <span style={value2}>{billNo ? billNo : (nextInvNo ?? "-")}</span>
                </div>

                {/* DATE */}
                <div style={row}>
                    <span style={label}>DATE</span>
                    <span style={colon}>:</span>
                    <span style={value}>
                        {billDate
                            ? dayjs(billDate).format("DD-MMM-YYYY hh:mm A")
                            : dayjs().format("DD-MMM-YYYY hh:mm A")}
                    </span>
                </div>

                <div style={row}>
                    <span style={label}>MOBILE</span>
                    <span style={colon}>:</span>
                    <span style={value}>{showValue(userDetails?.Mobileno) || "-"}</span>
                </div>

                <div style={row}>
                    <span style={label}>CUST NAME</span>
                    <span style={colon}>:</span>
                    <span style={value}>{showValue(userDetails?.Custname) || "-"}</span>
                </div>

                <div style={separator}></div>

                {/* TABLE HEADER */}
                <div style={rowWise}>
                    <span style={label}>SNO</span>
                    <span style={label}>PARTICULARS</span>
                    <span style={label}>QTY</span>
                    <span style={label}>RATE</span>
                    <span style={label}>DISC</span>
                    <span style={label}>AMOUNT</span>
                </div>

                <div style={separator}></div>

                {/* ITEM */}
                {barCodeData.map((item, index) => {
                    const sno = index + 1;
                    const code = (item.DesignCode || "").substring(0, 14);
                    const qty = item.stock ?? item.QTY ?? 1;
                    const rate = Number(item.CPrice ?? 0);
                    const discAmt = Number(item.Disamt ?? 0);
                    const discPer = Number(item.Disper) > 0 ? Number(item.Disper) : "";
                    const offer = Number(item.offer ?? item.SellPrice ?? rate);
                    const amount = qty * offer;

                    const prodLineParts = [
                        item?.HSNCODE && isValidValue(item.HSNCODE)
                            ? `HSN:${item.HSNCODE}`
                            : null,
                        item?.GST && Number(item.GST) > 0
                            ? `GST:${item.GST}%`
                            : null,
                        item?.SMCODE && isValidValue(item.SMCODE)
                            ? `SM:${item.SMCODE}`
                            : null,
                        item?.Prodsize && isValidValue(item.Prodsize)
                            ? `SZ:${item.Prodsize}`
                            : null,
                    ].filter(Boolean);

                    const prodLine = prodLineParts.join("  ");

                    const productName = (
                        item.ProdName ||
                        item.PRODUCTNAME ||
                        ""
                    ).substring(0, 30);

                    return (
                        <React.Fragment key={index}>
                            <div style={rowWise}>
                                <span style={label}>{sno}</span>
                                <span style={label2}>{code}</span>
                                <span style={label}>{qty}</span>
                                <span style={label}>{rate}</span>
                                <span style={label}>
                                    {discAmt}
                                    {discPer > 0 && (
                                        <div style={{ fontSize: "9px" }}>
                                            {discPer}%
                                        </div>
                                    )}
                                </span>
                                <span style={label}>{amount}</span>
                            </div>

                            <div style={{ ...bea, marginLeft: "30px" }}> {/* ⭐ CHANGE */}
                                {productName}
                            </div>

                            <div style={{ ...bea, marginLeft: "30px" }}> {/* ⭐ CHANGE */}
                                {prodLine}
                            </div>

                            <div style={separator}></div>
                        </React.Fragment>
                    );
                })}

                {/* TOTAL SECTION */}

                <div style={totalRow}>
                    <div style={row}>
                        <span style={label}>TOT QTY</span>
                        <span style={colon}>:</span>
                        <span style={value}>{totalBillQty ?? 0}</span>
                    </div>

                    <div style={totalBlock}>
                        <div style={totalLine}>
                            <span style={totalLine2}>TOTAL.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue}>{formatNum(totalBillAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>

                        <div style={totalLine}>
                            <span style={totalLine2}>DIS.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue}>{formatNum(totalBillDiSAmt, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>

                        <div style={totalLine}>
                            <span style={totalLine3}>NET.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue2}>{formatNum(totalBillNetAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>
                    </div>
                </div>
                <div style={separator}></div>
                <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: 6, fontSize: "12px" }}>
                    EXCHANGE
                </div>

                <div style={separator}></div>
                <div style={totalRow}>
                    <div style={row}>
                        <span style={label}>TOT QTY</span>
                        <span style={colon}>:</span>
                        <span style={value}>{totalExchangeQty ?? 0}</span>
                    </div>

                    <div style={totalBlock}>
                        <div style={totalLine}>
                            <span style={totalLine2}>EXCH.TOT.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue}>{formatNum(totalExchangeAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>

                        <div style={totalLine}>
                            <span style={totalLine2}>EXCH.DIS.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue}>{formatNum(totalExchangeDiSAmt, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>

                        <div style={totalLine}>
                            <span style={totalLine3}>EXCH NET.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue2}>{formatNum(totalExchangeNetAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>
                    </div>
                </div>
                <div style={separator}></div>
                <div style={totalRow}>
                    <div style={row}>
                        {/* <span style={label}>TOT QTY</span>
                        <span style={colon}>:</span>
                        <span style={value}>{totalExchangeQty ?? 0}</span> */}
                    </div>

                    <div style={totalBlock}>
                        <div style={totalLine}>
                            <span style={totalLine2}>INV.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue}>{formatNum(totalBillNetAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>

                        <div style={totalLine}>
                            <span style={totalLine2}>EXCH.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue}>{formatNum(totalExchangeNetAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>

                        <div style={totalLine}>
                            <span style={totalLine3}>BALANCE.AMT</span>
                            <span style={totalColon}>:</span>
                            <span style={totalValue2}>{formatNum(totalNetAmount, 2)}</span>
                            {/* <span style={totalValue}>100000</span> */}

                        </div>
                    </div>
                </div>

                {gstValue === true && totalGstData?.length > 0 && (
                    <>

                        <div style={separator}></div>
                        <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: 6, fontSize: "12px" }}>
                            GST SUMMARY
                        </div>

                        <div style={separator}></div>

                        {/* GST TABLE HEADER */}
                        <div style={rowWise}>
                            <span style={label4}>BASIC</span>
                            <span style={label4}>CGST%</span>
                            <span style={label4}>CGST AMT</span>
                            <span style={label4}>SGST%</span>
                            <span style={label4}>SGST AMT</span>
                            <span style={label4}>NET</span>
                        </div>

                        <div style={separator}></div>

                        {/* GST TABLE ROWS */}
                        {totalGstData.map((gstRow, index) => {

                            const basicAmt = Number(gstRow.Basic_amt ?? 0).toFixed(2);
                            const cgstPer = Number(gstRow.CGST_RATE ?? gstRow.CGST ?? 0);
                            const cgstAmt = Number(gstRow.CGST_AMT ?? 0).toFixed(2);
                            const sgstPer = Number(gstRow.SGST ?? 0);
                            const sgstAmt = Number(gstRow.SGST_AMT ?? 0).toFixed(2);
                            const netAmt = Number(gstRow.NET_AMT ?? 0).toFixed(2);

                            return (
                                <div key={index} style={rowWise}>
                                    <span style={label4}>{basicAmt}</span>
                                    <span style={label4}>{cgstPer}%</span>
                                    <span style={label4}>{cgstAmt}</span>
                                    <span style={label4}>{sgstPer}%</span>
                                    <span style={label4}>{sgstAmt}</span>
                                    <span style={label4}>{netAmt}</span>
                                </div>
                            );
                        })}

                    </>
                )}

                <div style={separator}></div>

                {/* PAYMENT */}
                <div style={cashOrOnline}>
                    <span>CASH PAID
                        {/* <span>:</span> */}
                        <span style={cashOrOnline2}>{formatNum(cashAmt, 2)}</span></span>
                    {cardAmt > 0 && (
                        <span>
                            CARD PAID
                            <span style={cashOrOnline2}>
                                {formatNum(cardAmt, 2)}
                            </span>
                        </span>
                    )}

                    {upiAmt > 0 && (
                        <span>
                            UPI PAID
                            <span style={cashOrOnline2}>
                                {formatNum(upiAmt, 2)}
                            </span>
                        </span>
                    )}

                    {onlineAmt > 0 && (
                        <span>
                            ONLINE PAID
                            <span style={cashOrOnline2}>
                                {formatNum(onlineAmt, 2)}
                            </span>
                        </span>
                    )}

                    {creditAmt > 0 && (
                        <span>
                            CREDIT
                            <span style={cashOrOnline2}>
                                {formatNum(creditAmt, 2)}
                            </span>
                        </span>
                    )}
                </div>

                <div style={{ textAlign: "center", fontSize: "14px", fontWeight: 600, marginTop: "5px" }}>
                    ****Terms & Conditions****
                </div>

                <div style={terms}>{ins}</div>
                <div style={terms}>{ins1}</div>
                <div style={terms}>{ins2}</div>
                <div style={terms}>{ins3}</div>
                <div style={terms}>{ins4}</div>
                <div style={terms}>{ins5}</div>

                <div style={{ textAlign: "center" }}>

                    {/* {base64Images && (
                        <img
                            src={base64Images}
                            alt="logo"
                            style={{
                                maxWidth: "120px",
                                display: "block",
                                margin: "0 auto"
                            }}
                        />
                    )} */}

                    {upiAmt > 0 && base64QR && (
                        <img
                            src={base64QR}
                            alt="qr-code"
                            style={{
                                maxWidth: "150px",
                                display: "block",
                                margin: "5px auto"
                            }}
                        />
                    )}

                </div>

                <div style={{ fontWeight: 500,fontSize:"12px",marginTop:"10px" }}>
                    PRINT TIME : {dayjs().format("hh:mm A")}
                </div>

                <div style={footer}>
                    Thank you for shopping please visit again!
                </div>
            </div>
        </>
    );
});

export default DirectPrint;
